jQuery(function ($) {
    const body = $('body');
    const top = $('#top');
    const searchForm = top.find('.search-form');
    const mobileWidth = 1024
    let currentWidth = $(window).width();
    let isMobile = true;
    let mobileMenuOpen = false;

    $('.submenu').hover(function () {
        if (isMobile) {
            return;
        }
        if (!isV2()) {
            body.addClass('overlay')
        }
        top.removeClass('border-white')
            .addClass('border-gray')

        if (isV2()) {
            const $li = $(this);
            const $arrow = $li.find('> a .submenu-arrow');
            const $megaMenu = $li.find('> .mega-menu');
            if ($arrow.length && $megaMenu.length) {
                $megaMenu.css({ left: '', right: '' });

                const arrowRect = $arrow[0].getBoundingClientRect();
                const arrowCenter = arrowRect.left + arrowRect.width / 2;
                const megaRect = $megaMenu[0].getBoundingClientRect();

                if (megaRect.right > window.innerWidth - 20) {
                    $megaMenu.css({ left: 'auto', right: '0' });
                    const flippedRect = $megaMenu[0].getBoundingClientRect();
                    $megaMenu.css('--arrow-left', (arrowCenter - flippedRect.left) + 'px');
                } else {
                    $megaMenu.css('--arrow-left', (arrowCenter - megaRect.left) + 'px');
                }
            }
        }
    }, function () {
        if (!isMobile && isV2()) {
            $(this).find('> .mega-menu').css({ left: '', right: '', '--arrow-left': '' });
        }
        $(document).trigger('closeDesktopSubMenu');
    })

    var pageTopTimer;
    $('#page-top').on('mouseenter', '.menu-item-has-children', function () {
        clearTimeout(pageTopTimer);
        $(this).addClass('is-open');
    }).on('mouseleave', '.menu-item-has-children', function () {
        var $li = $(this);
        pageTopTimer = setTimeout(function () {
            $li.removeClass('is-open');
        }, 200);
    });

    var mainMenu = $('#main-menu > nav')
    $('#mobile-menu').click(function () {
        mobileMenuOpen = true;

        if (!$('#menu-overlay').length) {
            body.append($('<div/>',{
                id: 'menu-overlay'
            }))
        }

        if (!mainMenu.find('.menu-header').length) {
            mainMenu.find('> ul').prepend(
                $('<li>')
                    .addClass('menu-header')
                    .append(
                        $('<a>')
                            .attr({
                                href: 'javascript:void(0);',
                                'data-close-menu': '',
                            })
                    )
                    .append(getCloseButton())
            )
        }

        mainMenu.prependTo(body);

        $('#trustbadge-container-98e3dadd90eb493088abdc5597a70810').hide()
    })

    mainMenu.find('> ul > li > a').click(function (e) {
        var li = $(this).closest('li')

        if (!li.hasClass('submenu') || !isMobile) {
            return;
        }

        e.preventDefault()

        var subMenu = li.find('> div');

        $('<div>')
            .append(
                $('<a>')
                    .attr({
                        href: 'javascript:void(0);',
                        'data-back-to-parent': '',
                    })
                    .addClass('submenu-close')
                    .html('<svg class="w-3 h-2.5 mr-2 inline-block align-middle rotate-180"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrowRightIcon"></use></svg>Ga terug')
            )
            .append(getCloseButton())
            .addClass('menu-header')
            .prependTo(subMenu);

        subMenu.css('display', 'flex')
            .addClass('slide-in');

        li.addClass('open');
    })

    mainMenu.on('click', '.mega-menu .menu-sub-items > li > a, .mega-menu .menu-sub-items > li > span', function (e) {
        if (!isMobile) {
            return;
        }

        var li = $(this).closest('li');
        var level3 = li.find('> ul.menu-level-3');

        if (!level3.length) {
            return;
        }

        e.preventDefault();

        // Store original parent so we can restore on close
        level3.data('level3-parent', li);

        // Move to nav root — same positioning context as the mega-menu
        level3.appendTo(mainMenu);

        if (!level3.find('> .menu-header').length) {
            $('<div>')
                .addClass('menu-header')
                .append(
                    $('<a>')
                        .attr({
                            href: 'javascript:void(0);',
                            'data-back-to-level2': '',
                        })
                        .addClass('submenu-close')
                        .html('<svg class="w-3 h-2.5 mr-2 inline-block align-middle rotate-180"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrowRightIcon"></use></svg>Ga terug')
                )
                .append(getCloseButton())
                .prependTo(level3);
        }

        // Apply all positioning inline — same as how the mega-menu is positioned
        var megaBg = li.closest('.mega-menu').css('background-color');
        level3.css({
            position: 'absolute',
            top: 0,
            left: '100%',
            width: '100%',
            height: '100%',
            'z-index': 200,
            display: 'flex',
            'flex-direction': 'column',
            'overflow-y': 'auto',
            'background-color': megaBg
        }).addClass('slide-in');

        li.addClass('level3-open');
    })

    mainMenu.find('.mobile-menu-items').on('click', '.menu-item-has-children > a', function (e) {
        if (!isMobile) {
            return;
        }

        e.preventDefault();

        var li = $(this).closest('li');
        var subMenu = li.find('> ul');

        if (!subMenu.find('.menu-header').length) {
            $('<li>')
                .addClass('menu-header')
                .append(
                    $('<a>')
                        .attr({
                            href: 'javascript:void(0);',
                            'data-back-to-parent': '',
                        })
                        .addClass('submenu-close')
                        .html('<svg class="w-3 h-2.5 mr-2 inline-block align-middle rotate-180"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrowRightIcon"></use></svg>Ga terug')
                )
                .append(getCloseButton())
                .prependTo(subMenu);
        }

        subMenu.css('display', 'flex').addClass('slide-in');

        li.addClass('open');
    })

    $(document)
        .on('click', '[data-close-menu]', function (e) {
            $(document).trigger('closeMobileMenu');
        })
        .on('click', '[data-back-to-parent]', function (e) {
            $(document).trigger('closeMobileSubMenu');
        })
        .on('click', '[data-back-to-level2]', function (e) {
            $(document).trigger('closeMobileLevel3');
        })
        .on('click', '#menu-overlay', function() {
            $(document).trigger('closeMobileMenu');
        })
        .on('closeMobileMenu', function () {
            $('.menu-header').remove();
            $('#menu-overlay').remove();

            $(document).trigger('closeMobileSubMenu');
            $(document).trigger('hideSearchForm');

            mainMenu.prependTo($('#main-menu'))
            mobileMenuOpen = false;
        })
        .on('closeMobileLevel3', function () {
            $('.menu-level-3').each(function () {
                var $l3 = $(this);
                var parentLi = $l3.data('level3-parent');
                $l3.find('> .menu-header').remove();
                $l3.removeClass('slide-in').css({
                    position: '', top: '', left: '', width: '', height: '',
                    'z-index': '', display: '', 'flex-direction': '',
                    'overflow-y': '', 'background-color': ''
                });
                if (parentLi && parentLi.length) {
                    $l3.appendTo(parentLi);
                    $l3.removeData('level3-parent');
                }
            });
            $('.menu-sub-items > li.level3-open').removeClass('level3-open');
        })
        .on('closeMobileSubMenu', function () {
            $(document).trigger('closeMobileLevel3');
            $('.mega-menu').removeClass('slide-in').attr('style', '');
            $('.mobile-menu-items li.open > .sub-menu').removeClass('slide-in').attr('style', '');
            $('.submenu-close').closest('.menu-header').remove();
            $('.submenu.open').removeClass('open');
            $('.menu-item-has-children.open').removeClass('open');
            $('#trustbadge-container-98e3dadd90eb493088abdc5597a70810').show()
        })
        .on('closeDesktopSubMenu', function () {
            if (!mobileMenuOpen) {
                 body.removeClass('overlay')
            }

            top.addClass('border-white')
                .removeClass('border-gray')
        })
        .on('hideSearchForm', function () {
            searchForm.prependTo($('#main-menu').find('.header-actions'));
        })

    $(window).resize(function () {
        isMobile = $(this).width() < mobileWidth;

        // We need to check if the width has been changed to prevent unnecessary redraws
        if ($(this).width() === currentWidth) {
            return;
        }

        currentWidth = $(this).width();

        if (isMobile) {
            $(document).trigger('closeDesktopSubMenu');
        } else {
            $(document).trigger('closeMobileMenu');
        }
    }).resize();

    $('[data-toggle-search-form]').click(function(){
        if (top.find('> .search-form').length === 1) {
            $(document).trigger('hideSearchForm');

            return;
        }

        searchForm.appendTo(top)
        searchForm.find('input').focus();
    });

    function getCloseButton()
    {
        return $('<a>')
            .attr({
                'href': 'javascript:void(0);',
                'data-close-menu': '',
            })
            .addClass('close-button')
            .html('<svg xmlns="http://www.w3.org/2000/svg" width="9.9" height="9.9" viewBox="0 0 9.9 9.9">\n' +
                '  <line id="Line_75" data-name="Line 75" x2="11" transform="translate(1.061 8.839) rotate(-45)" fill="none" stroke="#f6f0e7" stroke-linecap="round" stroke-width="1.5"/>\n' +
                '  <line id="Line_77" data-name="Line 77" x2="11" transform="translate(1.061 1.061) rotate(45)" fill="none" stroke="#f6f0e7" stroke-linecap="round" stroke-width="1.5"/>\n' +
                '</svg>');
    }
})